import { IconButton, TableCell, Tooltip } from "@mui/material";
import { Autorenew, Description, PersonAdd } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useFormatter } from "../../../utils/useFormatter";
import { useState } from "react";
import { CreateAppointmentDialog } from "../../schedulemanager/components/creatappointmentdialog";
import { useViewContext } from "../../../contexts/ViewContext";
import { useContractContext } from "../../../contexts/ContractContext";
import { currentFeatures } from "@/configs/Settings";
import { DocumentReissueShortcutDialog } from "./DocumentReissueShortcutDialog";

/** Resolve patientId no mesmo formato usado em navigate("/summary"). */
function resolvePatientId(row: any): string {
  if (!row?.identifier) return "";
  return currentFeatures.defaultApp
    ? row.identifier.replace(/[^a-zA-Z0-9]/g, "")
    : row.identifier;
}

export function PatientSearchActions({ row }: any) {
  const { currentContract } = useContractContext();
  const { availableRoles } = useViewContext();
  const navigate = useNavigate();
  const [createAppointmentDialogOpen, setCreateAppointmentDialogOpen] =
    useState<boolean>(false);
  const [isShortCutAppointment, setIsShortCutAppointment] =
    useState<boolean>(false);
  const [reissueDialogOpen, setReissueDialogOpen] = useState(false);

  const isPractitioner = availableRoles?.includes("practitioner");
  const patientId = resolvePatientId(row);

  return (
    <TableCell align="center">
      {currentFeatures.defaultApp && (
        <Tooltip title="Preencher vaga">
          <IconButton
            onClick={() => {
              setCreateAppointmentDialogOpen(true);
              setIsShortCutAppointment(true);
            }}
            // disabled={!currentContract}
          >
            <PersonAdd />
          </IconButton>
        </Tooltip>
      )}

      {createAppointmentDialogOpen && (
        <CreateAppointmentDialog
          isOpen={createAppointmentDialogOpen}
          setModalOpen={setCreateAppointmentDialogOpen}
          cpfT={useFormatter.formatCPF(row?.identifier)}
          walkin={false}
          isShortCutAppointment={isShortCutAppointment}
        />
      )}

      {isPractitioner && (
        <Tooltip title="Reemitir documento">
          <IconButton
            onClick={() => {
              if (patientId) setReissueDialogOpen(true);
            }}
            disabled={!patientId}
          >
            <Autorenew />
          </IconButton>
        </Tooltip>
      )}

      {isPractitioner && (
        <Tooltip title="Acessar Registros ">
          <IconButton
            onClick={() => {
              if (row.identifier)
                navigate("/summary", {
                  state: {
                    patientId,
                  },
                });
            }}
          >
            <Description />
          </IconButton>
        </Tooltip>
      )}

      {reissueDialogOpen && patientId ? (
        <DocumentReissueShortcutDialog
          open={reissueDialogOpen}
          onClose={() => setReissueDialogOpen(false)}
          patientId={patientId}
          patientName={row?.name}
        />
      ) : null}
    </TableCell>
  );
}
